import { tv } from 'tailwind-variants'

export const focusRing = tv({
  base: 'outline-ring outline-offset-1 outline-0 data-[focus-visible]:outline-2',
})
